export default __webpack_public_path__ + "static/media/grayX.4ffd3e9f.svg";